import { mapState, mapGetters } from 'vuex'

export const computed = {
  ...mapState({
    hoaId: state => state.user.selectedHoaId
  }),
  ...mapGetters('unit', ['statesList'])
}
